export const NL_SLUGS = {
  "/services": "/diensten",
  "/how-it-works": "/hoe-het-werkt",
  "/pricing": "/prijzen",
  "/industries": "/sectoren",
  "/about": "/over-ons",
  "/terms": "/voorwaarden",
};
const EN_SLUGS = Object.fromEntries(Object.entries(NL_SLUGS).map(([en, nl]) => [nl, en]));

export const toNlPath = (enPath) => {
  const [p, hash] = enPath.split("#");
  const base = p === "/" ? "/nl" : `/nl${NL_SLUGS[p] || p}`;
  return hash ? `${base}#${hash}` : base;
};

export const toEnPath = (nlPathname) => {
  const sub = nlPathname === "/nl" ? "/" : nlPathname.slice(3) || "/";
  return EN_SLUGS[sub] || sub;
};
